<div class="page-wrapper">
    <div class="page-header list-page-header mb-3">
        <h4 class="page-title">LGA Settings</h4>

        <div class="tab-actions py-1">
            <div class="d-flex gap-2 align-items-center flex-wrap">
                <!-- <div class="search-container">
                    <div class="amc-search-bar" (click)="toggleSearch()">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.2094 13.7386L12.9178 11.4981L12.8641 11.4164C12.7643 11.317 12.6277 11.261 12.4852 11.261C12.3426 11.261 12.2061 11.317 12.1062 11.4164C10.1587 13.2031 7.15783 13.3002 5.09373 11.6434C3.02964 9.98651 2.54284 7.08981 3.95619 4.87434C5.36953 2.65888 8.24444 1.81213 10.6743 2.89565C13.1041 3.97918 14.3349 6.65676 13.5504 9.15262C13.4939 9.33293 13.5401 9.52901 13.6716 9.66701C13.803 9.805 13.9998 9.86394 14.1878 9.82162C14.3757 9.7793 14.5263 9.64216 14.5828 9.46185C15.5207 6.49999 14.1042 3.3126 11.2498 1.9616C8.39539 0.610603 4.95962 1.50144 3.1651 4.05784C1.37058 6.61423 1.75585 10.069 4.07168 12.1872C6.38752 14.3055 9.93892 14.4515 12.4285 12.5308L14.4575 14.5146C14.6671 14.7186 15.0058 14.7186 15.2154 14.5146C15.4247 14.3077 15.4247 13.9746 15.2154 13.7678L15.2094 13.7386Z"
                                fill="#667085" />
                        </svg>
                        <span>Search</span>
                    </div>
                </div> -->

                <div class="d-flex flex-row align-items-center text-nowrap">
                    <button class="custom-btn-secondary" (click)="open()">
                        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="white"
                                d="M13.2573 11.9509C10.322 10.9829 10.3845 10.0461 9.91609 10.4833C9.91609 10.2023 9.94732 9.92122 9.97854 9.64018C10.6031 9.01566 11.1027 8.11009 11.3213 7.0484C11.415 6.89227 11.5399 6.76736 11.6335 6.36142C12.0083 5.14359 11.5399 5.01869 11.5086 4.98746C11.6023 4.55029 11.7584 3.36369 11.5399 2.70794C11.1027 1.36521 8.69826 0.584548 8.16741 0.459643C7.1994 0.0224742 5.04478 1.17785 4.54516 2.70794C4.32658 3.36369 4.48271 4.51907 4.57639 4.98746C4.10799 5.3934 4.42026 6.48632 4.70129 6.95472C4.48271 7.29821 4.10799 8.07887 4.48271 8.67217C4.70129 9.01566 5.13846 9.17179 5.76299 9.17179C5.88789 9.35915 6.04402 9.51528 6.20016 9.67141C6.23138 9.92122 6.23138 10.2023 6.23138 10.4833C6.10648 10.3584 5.91912 10.3584 5.79421 10.4833C5.79421 10.4833 4.91988 11.3264 2.89017 11.9822C-0.201241 13.1375 0.329606 17.4468 0.485738 18.3211V18.3523C0.610643 19.0393 0.673096 19.2267 0.860454 19.3203C4.10799 20.7568 12.0707 20.7568 15.287 19.3203C15.5056 19.2267 15.5681 19.0393 15.693 18.3523C15.693 18.3211 15.693 18.3211 15.693 18.2899V18.3211C15.8179 17.4155 16.3799 13.1375 13.2573 11.9509ZM5.13846 2.8953C5.48195 1.89605 6.94959 0.896811 7.73025 0.99049C8.66704 1.14662 10.6343 1.98973 10.9466 2.8953C11.0715 3.30124 11.009 4.05067 10.9466 4.55029C8.69826 4.33171 7.82393 2.83284 7.7927 2.77039C7.73025 2.67671 7.63657 2.61426 7.51166 2.61426C7.38676 2.61426 7.29308 2.67671 7.23062 2.80162C6.85591 3.55105 5.85667 4.17558 5.10723 4.55029C5.07601 4.01944 5.01356 3.30124 5.13846 2.8953ZM4.98233 8.29745C4.88865 8.17255 4.91988 7.98519 4.98233 7.79783C5.07601 8.04764 5.16969 8.26623 5.29459 8.48481C5.10723 8.42236 5.01356 8.3599 4.98233 8.29745ZM9.29156 10.171V10.9829C8.41723 11.545 7.66779 11.5138 6.82468 10.9829C6.82468 10.7019 6.85591 10.4521 6.82468 10.171C7.63657 10.6394 8.44845 10.6707 9.29156 10.171ZM15.0684 18.165C15.006 18.5085 14.9748 18.6646 14.9435 18.727C11.8209 20.0386 4.32658 20.0386 1.20394 18.727C1.17272 18.6646 1.14149 18.5085 1.07904 18.165V18.1337C0.954133 17.3531 0.454512 13.5122 3.07752 12.513C4.67007 11.9822 5.60686 11.3889 5.98157 11.0766C7.35553 12.2944 8.79194 12.2944 10.1347 11.0766C10.5406 11.3889 11.4462 11.9822 13.0387 12.513C15.693 13.5435 15.1933 17.4155 15.0684 18.165Z" />
                        </svg>
                        Create LGA Settings
                    </button>
                </div>
            </div>
        </div>
    </div>





    <!-- <div class="table-responsive"> -->
    <div class="panel-div">
        <div class="table-wrapper">
            <form class="search-form" [formGroup]="featureSearchForm" *ngIf="showSearch">
                <span (click)="toggleSearch()" class="material-symbols-outlined text-danger ms-auto">close</span>
                <div class="row mt-2 mb-3 align-items-end">
                    <div class="col-md-3">
                        <label>MDA Name</label>
                        <input type="text" class="form-control small-option-font" formControlName="mdaName" />
                    </div>
                    <!-- <div class="col-md-3">
                            <label>Zone</label>
                            <ng-select [items]="allZones" bindLabel="name" bindValue="id" placeholder="Select Zone(s)" formControlName="zone" [multiple]="true" [hideSelected]="true" ></ng-select>
                        </div> -->
                    <div class="col-md-3">
                        <label>Station Name</label>
                        <input type="text" class="form-control small-option-font" formControlName="mdaCode" />
                    </div>
                    <!-- <div class="col-md-3">
                            <label>Payment Status</label>
                            <select class="form-control small-option-font" formControlName="paymentStatus">
                                <option value="">-- Select--</option>
                                <option value="PAID">Paid</option>
                                <option value="NOT_PAID">Not Paid</option>
                            </select>
                        </div> -->
                    <!-- <div class="col-md-3">
                            <label>Start Date</label>
                            <input type="date" class="form-control small-option-font" formControlName="from" />
                        </div>
        
                        <div class="col-md-3">
                            <label>End Date</label>
                            <input type="date" class="form-control small-option-font" formControlName="to" />
                        </div> -->
                    <div class="col-md-3 col-sm-9">
                        <button [disabled]="!featureSearchForm.valid" class="btn custom-btn-primary"
                            (click)="search(); toggleSearch()" type="submit">
                            Search
                        </button>
                    </div>
                    <a class="font-size-small ms-auto d-flex justify-content-end" style="width: max-content;"
                        (click)="clearFilterForm()"><small role="button">clear</small></a>
                </div>
            </form>
            <table class="amc-table" appAutoDataLabel>
                <thead class="amc-table-heading">
                    <tr>
                        <th class="text-center">S/N</th>
                        <th>MDA Name</th>
                        <th>MDA Code</th>
                        <th class="text-center">Logo</th>
                        <th class="text-center">Color</th>
                        <th class="text-center">Signature</th>
                        <th class="text-center">LGA Background</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
                <tbody *ngIf="!isSearching && details?.length > 0">
                    <tr *ngFor="let eachDetail of details; let i = index">
                        <td class="text-center">
                            {{ i + num + 1 }}
                        </td>
                        <td><span>{{ eachDetail?.department }}</span>
                        </td>
                        <td>{{eachDetail.acronym}}</td>
                        <td>
                            <div class="d-flex justify-content-center"><img [src]="eachDetail.logo" alt=""
                                    style="width: 50px; height: 50px; object-fit: contain;"></div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-center gap-3 h-100 align-items-center">
                                <div style="height: 20px; aspect-ratio: 4/1;"
                                    [ngStyle]="{ 'background-color': eachDetail.primaryBackgroundColor }">
                                </div>
                                <div style="height: 20px; aspect-ratio: 4/1;"
                                    [ngStyle]="{ 'background-color': eachDetail.primaryTextColor }">
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-center"><img [src]="eachDetail.headSignature" alt=""
                                    style="width: 50px; height: 50px; object-fit: contain;"></div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-center"><img [src]="eachDetail.lgaBgURL" alt=""
                                    style="width: 50px; height: 50px; object-fit: contain;"></div>
                        </td>
                        <td class="user-type-td">
                            <!-- <div class="d-flex w-100 justify-content-end justify-content-lg-center">
                                <div ngbDropdown class="d-inline ">
                                    <button class="btn btn-success btn-sm btn-flat" id="dropdownBasic1"
                                        ngbDropdownToggle type="button">
                                        Action
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-flat">
                                        <a (click)="edit(eachDetail)"
                                            style="font-family: Inter; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Edit
                                        </a>
                                        <a (click)="deleteMDAConfig(eachDetail.id)"
                                            style="font-family: Inter; font-size: 14px; font-style: normal;"
                                            ngbDropdownItem class="dropdown-item-flat pointer">
                                            Remove
                                        </a>
                                    </div>
                                </div>
                            </div> -->

                            <div class="amc-table-action-wrapper">
                                <span class="material-symbols-outlined action-icon" data-bs-toggle="dropdown">
                                    more_horiz
                                </span>
                                <div class="dropdown-menu amc-table-action-select">
                                    <div class="dropdown-wrapper">

                                        <button class="action-btn" (click)="view(eachDetail)">
                                            View
                                        </button>
                                        <button class="action-btn" (click)="deleteMDAConfig(eachDetail.id)">
                                            Remove
                                        </button>

                                        <!-- <div class="action-btn" *ngIf="item?.status == 'ACTIVE'" role="button"
                                      (click)="openTaxpayerModal(item);  $event.stopPropagation()">
                                      Update Taxpayer Profile
                                    </div> -->
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- </div> -->

    <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">

        <div class="d-flex align-items-center me-4">
            <div>Rows per page: </div>
            <div class="mx-2">
                <select class="form-control px-6 text-center" style="width: auto; min-width: 40px;"
                    [(ngModel)]="selectedLimit" (change)="updateLimit()">
                    <option [value]=1>1</option>
                    <option [value]=5>5</option>
                    <option [value]=10>10</option>
                    <option [value]=20>20</option>
                    <option [value]=30>30</option>
                    <option [value]=40>40</option>
                    <option [value]=50>50</option>

                </select>
            </div>
        </div>


        <div class="pagination-container">
            <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage" (pageChange)="callDb($event)"
                [maxSize]="5" [pageSize]="pageSize" [collectionSize]="count" [boundaryLinks]="true"
                [directionLinks]="true" [rotate]="true" class="pagination justify-content-center my-3">
            </ngb-pagination>
        </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
        <p *ngIf="isSearching" class="text-muted">Please wait...</p>
        <p *ngIf="isEmpty" class="text-danger">No features found</p>
    </div>


</div>